import { JOB_STATUS, JOB_STATUS_JA, LANGUAGE } from '../../constants';
import type { ValueFormatterParams } from 'ag-grid-community';
import type { Language, SelectOption } from '../../types/common';

/**
 * jobStatusの値を表示用にフォーマット
 * @param ValueFormatterParams （params.valueはnull/'0'/'1'/'2'/'3'）
 * @returns 0: 実行待 1: 実行中 2: 停止済 3: 完了"
 */
const jobStatusFormatter = (params: ValueFormatterParams) => {
  const value = params.value;
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const formattedValue: string = currentLang ? (currentLang.value === LANGUAGE.JA ? JOB_STATUS_JA[value] : JOB_STATUS[value]) : value;
  return formattedValue;
};

export default jobStatusFormatter;
